import { render } from "./BookAppointement.vue?vue&type=template&id=a424ce32"
import script from "./BookAppointement.vue?vue&type=script&lang=ts"
export * from "./BookAppointement.vue?vue&type=script&lang=ts"
script.render = render

export default script